import { Marquee } from './marquee.js';

window.addEventListener('DOMContentLoaded', (event) => {
    const element = document.querySelectorAll('[fr-marquee]');
    element.forEach((item) => new Marquee(item));
});
